<template>
  <!-- 店铺信息 -->
  <div class="shop-data">
    <!-- 已有店铺 正常展示 -->
    <div v-if="DisplayPage == '0' || DisplayPage == '5'">
      <p class="shop-title" v-if="DisplayPage == '0'">基本信息</p>
      <div class="Add-shop-title" v-else>
        <p class="shop-title">基本信息</p>
        <div class="Add-icon"></div>
        <p class="Add-button">添加保证金</p>
      </div>
      <!-- 公司名 logo -->
      <div class="shop-basic-msg">
        <BasicInformation v-if="DisplayPage == '0'"></BasicInformation>
        <FillOutBaoGold v-else></FillOutBaoGold>
      </div>
      <p class="shop-title">工商信息</p>
      <!-- 工商信息 -->
      <div class="shop-basic-msg">
        <FirmMessage></FirmMessage>
      </div>
      <!-- 服务范围 -->
      <div class="Add-shop-title">
        <p class="shop-title">服务范围</p>
        <div class="Add-icon firm-clickable" @click="handelServiceScope"></div>
        <p class="Add-button" @click="handelServiceScope">添加</p>
      </div>
      <div class="None" v-if="listArr.length == '0'">待添加</div>
      <div v-else>
        <div class="service" v-for="(item, index) in listArr" :key="index">
          <p class="title">{{ item.name }}</p>
          <div class="serviceItem">
            <p v-for="(item1, index1) in item.child" :key="index1">
              {{ item.name }}
            </p>
          </div>
        </div>
      </div>

      <!-- 企业详情 -->
      <div class="Add-shop-title firm-details">
        <p class="shop-title">企业详情</p>
        <div class="shop-EDITOR firm-clickable" @click="handelEnterpriseDetails"></div>
      </div>

      <div class="None" v-if="DetailData == ''">待添加</div>
      <div v-else class="firm-details-content">
        {{ DetailData }}
      </div>
      <!-- 案例信息 -->
      <div class="Add-shop-title firm-details" style="margin-top: 20px;">
        <p class="shop-title">案例信息</p>
        <div class="Add-icon firm-clickable" @click="DisplayPage = '1'"></div>
        <p class="Add-button" @click="DisplayPage = '1'">添加</p>
        <div class="delete firm-clickable" @click="handelDele"></div>
      </div>
      <div class="None" v-if="listArr1.length == '0'">待添加</div>
      <div class="case-box" v-else>
        <Case @handelEditCase="handelEditCase" :listArr="listArr1" :distinguish="1" :Clear="Clear"
          @handelChange="handelChange"></Case>
      </div>
      <!-- 分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging :pagingObj="pagingObj" @handleCurrentChange="handleCurrentChange"></paging>
        </div>
      </div>
      <!-- 申请店铺时 信息填写完毕 下一步 -->
      <div class="next" v-if="DisplayPage == '5'">
        <p>取消</p>
        <p class="next-p firm-clickable" @click="handleNext">下一步</p>
      </div>
    </div>
    <!-- 申请店铺 下一步 身份验证 -->
    <div v-if="DisplayPage == '6'">
      <Verify @handelVerifyReturn="DisplayPage = '5'" @handelVerifyOk="handelVerifyOk"></Verify>
    </div>

    <!-- 添加案例 -->
    <div v-if="DisplayPage == '1'">
      <CaseAdd @handelBack="handelBack"></CaseAdd>
    </div>
    <!-- 申请店铺 -->
    <div style="height: 100%" v-if="DisplayPage == '2' || DisplayPage == '3' || DisplayPage == '4'">
      <ApplyFor :DisplayPage="DisplayPage" @handelApplyFor="handelApplyFor"></ApplyFor>
    </div>
    <!-- 选择服务范围 -->
    <ServiceScope :dialogServiceScope="dialogServiceScope" @handleCloseServiceScope="dialogServiceScope = false"
      @ServiceScope="ServiceScope"></ServiceScope>
    <!-- 编辑企业详情 -->
    <EnterpriseDetails :EnterpriseDetails="EnterpriseDetails" @handleCloseEnterpriseDetails="EnterpriseDetails = false"
      @handelEnterpriseDetails="EnterpriseDetailsDio"></EnterpriseDetails>
  </div>
</template>

<script>
import BasicInformation from "./components/BasicInformation.vue"; // 基本信息
import FillOutBaoGold from "./components/FillOutBaoGold.vue"; // 添加保证金时展示的基本信息
import FirmMessage from "./components/FirmMessage.vue"; // 工商信息
import Case from "./components/Case.vue"; // 案例信息
import paging from "../../../../../components/paging.vue"; // 分页
import CaseAdd from "./caseAdd.vue"; // 添加案例
import ApplyFor from "./ApplyFor.vue"; // 没有店铺 立即申请
import Verify from "./Verify.vue"; // 没有店铺 申请店铺 下一步 身份验证
import ServiceScope from "./components/ServiceScope.vue"; // 选择服务范围
import EnterpriseDetails from "./components/EnterpriseDetails.vue"; // 编辑企业详情
export default {

  data() {
    return {
      listArr: [
        {
          name: "工商服务",
          child: [
            {
              name: "企业名称变更",
            },
            {
              name: "公司地址变更",
            },
            {
              name: "工商年报",
            },
          ],
        },
        {
          name: "财税服务",
          child: [
            {
              name: "个体户代账",
            },
            {
              name: "小规模代账",
            },
            {
              name: "一般纳税人代账",
            },
          ],
        },
      ], //服务范围
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 6, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      DetailData:
        "创意无限，品质至上！我们的宣传册设计服务，为您的品牌量身打造独特魅力。从构思到呈现，每一步都充满匠心与热情。让您的宣传册成为市场中的亮点，吸引更多目光。选择我们，让您的品牌故事在精美的设计中绽放光彩！", // 详情数据
      DisplayPage: "0", // 0已有店铺正常展示  1添加案例页面 2申请  3正在审核  4审核失败   5申请页面  6申请店铺身份验证
      listArr1: [
        {
          id: 0,
          choose: false, //选择 0未  1是
        },
        {
          id: 1,
          choose: false, //选择 0未  1是
        },
        {
          id: 2,
          choose: false, //选择 0未  1是
        },
      ], // 案例信息
      idArr: [], // 删除案例 选中案例的id集
      Clear: 0, //传给子组件监听此值发生变化即删除弹窗确认，清空id集合
      dialogServiceScope: false, //选择服务弹窗
      EnterpriseDetails: false, //企业详情编辑弹窗
    };
  },
  watch: {},
  components: {
    // 基本信息
    BasicInformation,
    // 工商信息内容
    FirmMessage,
    // 案例信息
    Case,
    // 分页
    paging,
    // 添加案例
    CaseAdd,
    // 没有店铺 立即申请
    ApplyFor,
    // 添加保证金时显示的公司基本信息
    FillOutBaoGold,
    // 申请店铺 下一步 身份验证
    Verify,
    // 服务范围
    ServiceScope,
    // 编辑企业详情
    EnterpriseDetails,
  },
  created() {
    // // 随后有接口 不用此判断方法
    if (
      sessionStorage.getItem("DisplayPage") != null &&
      sessionStorage.getItem("DisplayPage") != ""
    ) {
      this.DisplayPage = sessionStorage.getItem("DisplayPage");
    } else {
      this.DisplayPage = "0";
    }
  },
  destroyed() {
    sessionStorage.removeItem("DisplayPage");
  },
  methods: {
    // 企业详情编辑确认
    EnterpriseDetailsDio() {
      this.EnterpriseDetails = false;
    },
    // 企业详情点击编辑
    handelEnterpriseDetails() {
      this.EnterpriseDetails = true;
    },
    // 服务范围确认选择
    ServiceScope() {
      this.dialogServiceScope = false;
    },
    // 服务范围 添加选择
    handelServiceScope() {
      this.dialogServiceScope = true;
    },
    // 点击删除 选中的案例
    handelDele() {
      if (this.idArr.length == 0) {
        this.$tool.PromptBox("warning", "请至少勾选一条案例信息！");
      } else {
        this.$confirmWithScroll("是否删除勾选案例信息？", "提示").then(() => {
          this.Clear++;
          // 删除成功重新请求数据列表接口
        }).catch(() => {});
      }
    },
    // 案例选中/取消选中 数据发生变化
    handelChange(val) {
      // 获取子组件传过来的id集合
      this.idArr = val;
    },
    // 身份验证页面确认
    handelVerifyOk() { },
    // 申请店铺点击下一步跳转身份验证
    handleNext() {
      this.DisplayPage = "6";
    },
    // 点击案例跳转案例编辑页
    handelEditCase(val) {
      sessionStorage.setItem("DisplayPage", "1"); //会话存储
      this.DisplayPage = "1";
    },
    // 返回店铺信息首页
    handelBack() {
      sessionStorage.setItem("DisplayPage", "0"); //会话存储
      this.DisplayPage = "0";
    },
    // 点击立即申请
    handelApplyFor() {
      console.log("1111");
      this.DisplayPage = "5";
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      // this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
.shop-data {
  width: 100%;
  height: 100%;

  .shop-title {
    display: inline-block;
    min-width: 80px;
    height: 25px;
    background-image: url("../../../../../assets/imgs/zhuangshi@3x.svg");
    background-size: 100% 40%;
    background-repeat: no-repeat;
    background-position-y: bottom;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
  }

  //   基本信息
  .shop-basic-msg {
    width: 100%;
    min-height: 60px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .firm-details {
    margin-top: 10px;
  }

  // 服务范围
  .Add-shop-title {
    width: 100%;
    height: 25px;
    display: flex;
    margin-bottom: 30px;

    .Add-icon {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/tianjia@2x.svg");
      background-size: 100% 100%;
      margin: auto 0;
      margin-left: 30px;
      cursor: pointer;
    }

    .Add-button {
      font-size: 12px;
      color: #333333;
      line-height: 25px;
      margin-left: 5px;
      cursor: pointer;
    }

    .shop-EDITOR {
      width: 20px;
      height: 20px;
      background-image: url("../../../../../assets/imgs/bianji@3x.svg");
      background-size: 100% 100%;
      margin: auto 0;
      margin-left: 30px;
    }

    .delete {
      width: 20px;
      height: 20px;
      background-image: url("../../../../../assets/imgs/shanchu@3x.svg");
      background-size: 100% 100%;
      margin: auto 0;
      margin-left: 30px;
    }
  }

  // 服务
  .service {
    width: 100%;
    min-height: 70px;

    .title {
      width: 100%;
      height: 17px;
      line-height: 17px;
      font-size: 14px;
      color: #333333;
    }

    .serviceItem {
      width: 100%;
      min-height: 55px;
      display: flex;
      flex-wrap: wrap;
      margin-top: 5px;

      p {
        min-width: 110px;
        height: 33px;
        line-height: 33px;
        background: rgba(97, 144, 232, 0.2);
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        margin-bottom: 20px;
        margin-right: 20px;
      }
    }
  }

  //企业详情
  .firm-details-content {
    width: 100%;
    min-height: 50px;
    line-height: 25px;
    font-size: 12px;
    color: #333333;
    letter-spacing: 1px;
    text-indent: 28px;
  }

  // 案例信息
  .case-box {
    width: 100%;
    min-height: 150px;
  }

  // 申请店铺时点击下一步
  .next {
    width: 100%;
    height: 40px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;

    p {
      width: 120px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #999999;
      border-radius: 5px;
      font-size: 16px;
      color: #333333;
      text-align: center;
      line-height: 40px;
      margin-left: 20px;
    }

    .next-p {
      background: #409eff ;
      color: #ffffff;
    }
  }
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}

// 无数据 待添加
// 无数据
.None {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px dashed #409eff ;
  border-radius: 5px;
  font-size: 12px;
  color: #333333;
  font-weight: 400;
}
</style>
